import { render } from "./PerkNpt.vue?vue&type=template&id=67939868&scoped=true"
import script from "./PerkNpt.vue?vue&type=script&lang=js"
export * from "./PerkNpt.vue?vue&type=script&lang=js"

import "./PerkNpt.vue?vue&type=style&index=0&id=67939868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67939868"]])

export default __exports__